module.exports = __webpack_public_path__ + "static/Birds_01-33a07b9a512fb7ddf2b87cd267f9d174.webp";